import { create } from "zustand";
import { IIPBBStoreState } from "./ipbbStore.type";

const useIPBBStore = create<IIPBBStoreState>((set) => ({
  ipbbDetails: null,
  setIpbbDetails: (data) => {
    set({ ipbbDetails: data });
    return data;
  },
  clearIpbbDetails: () => set({ ipbbDetails: null }),
}));

export { useIPBBStore };
